import { IsInt, IsOptional } from 'class-validator';

export interface OrderGetRequestRaw {
    orderId?: number | string;
    areaId?: number;
}

export class OrderGetRequest {
    @IsInt()
    public orderId: number;

    @IsOptional()
    @IsInt()
    public areaId?: number;

    constructor(data?: OrderGetRequestRaw) {
        this.orderId = typeof data?.orderId === 'string' ? parseInt(data.orderId, 10) : data?.orderId;
        this.areaId = data?.areaId;
    }
}
